import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';

function UserDropdown({ user, onLogout }) {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const userInitial = (user?.name || user?.email || 'U')[0].toUpperCase();
    const userName = user?.name || user?.email || 'User';
    const userEmail = user?.email || '';

    // Placeholder image logic or use initial if no image
    // The requirement provided HTML with an image src, we can keep it or fallback
    const userImage = "/docs/images/people/profile-picture-5.jpg"; // Keeping static as requested, or replace with real logic

    return (
        <div className="relative" ref={dropdownRef}>
            <button
                type="button"
                className="flex text-sm bg-gray-800 rounded-full focus:ring-4 focus:ring-gray-300"
                onClick={() => setIsOpen(!isOpen)}
            >
                <span className="sr-only">Open user menu</span>
                <div className="w-8 h-8 rounded-full bg-indigo-600 flex items-center justify-center text-white font-bold text-sm">
                    {userInitial}
                </div>
            </button>

            {/* Dropdown menu */}
            {isOpen && (
                <div className="absolute right-0 top-full mt-2 z-50 bg-white divide-y divide-gray-100 rounded-lg shadow-lg w-72 border border-gray-200">
                    <div className="p-3">
                        <div className="flex items-center gap-3 px-3 py-2 bg-gray-50 rounded-lg">
                            <div className="w-10 h-10 rounded-full bg-indigo-600 flex items-center justify-center text-white font-bold text-lg shrink-0">
                                {userInitial}
                            </div>
                            <div className="min-w-0">
                                <div className="font-medium text-gray-900 truncate">{userName}</div>
                                <div className="text-sm text-gray-500 truncate">{userEmail}</div>
                            </div>
                            <span className="ml-auto bg-indigo-50 border border-indigo-200 text-indigo-700 text-xs font-medium px-1.5 py-0.5 rounded">PRO</span>
                        </div>
                    </div>
                    <ul className="py-2 text-sm text-gray-700">
                        <li>
                            <Link to="/settings/account" className="flex items-center px-4 py-2 hover:bg-gray-100" onClick={() => setIsOpen(false)}>
                                <svg className="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                </svg>
                                Account
                            </Link>
                        </li>
                        <li>
                            <Link to="/settings" className="flex items-center px-4 py-2 hover:bg-gray-100" onClick={() => setIsOpen(false)}>
                                <svg className="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                                Settings
                            </Link>
                        </li>
                    </ul>
                    <div className="py-2">
                        <button
                            onClick={onLogout}
                            className="flex items-center w-full px-4 py-2 text-sm text-red-600 hover:bg-gray-100"
                        >
                            <svg className="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                            </svg>
                            Sign out
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default UserDropdown;
